import PropTypes from 'prop-types'

import {List, Map} from 'immutable'

import {Box, List as MuiList, ListItem} from '@mui/material'

import StatBox from '../../../../../shared_components/StatBox'
import Tooltip from '../../../../../shared_components/mui_base_components/tooltip/ToolTip'

import {humanizedFullName} from '../../../../../lib/nameTools'
import {pluralize} from '../../../../../lib/tools'

import './statistics.scss'

const Statistics = ({everplanSummary, isLimitedClient, isQuarterback, itemResponses = List()}) => {
  const summaryStartedSectionsCount = everplanSummary.get('completed-items').size

  const liveStartedSectionsCount = itemResponses.count(
    itemResponse => itemResponse.get('response-groups', List()).size > 0
  )

  const startedSectionsCount = Math.max(summaryStartedSectionsCount, liveStartedSectionsCount)
  const deputiesCount = everplanSummary.get('deputies-count')
  const draftDeputiesCount = everplanSummary.get('draft-deputies').size || 0

  const draftDeputiesNames = everplanSummary.get('draft-deputies').map(
    deputy => humanizedFullName(deputy)
  )

  const tooltipTitle = (
    draftDeputiesCount > 0 ?
      (
        <Box className='deputy-invites-tooltip-content'>
          <MuiList>
            {draftDeputiesNames.map((name, index) => (
              <ListItem key={index}>{name}</ListItem>
            ))}
          </MuiList>
        </Box>
      ) :
      (
        <Box className='deputy-invites-tooltip-content'>
          You have not drafted any Deputy invitations.
        </Box>
      )
  )

  return (
    <section className='statistics row-wrapper'>
      <StatBox
        boxStyle='black-box'
        className='updated'
        dataTestid='sections-started'
        label={`${pluralize('Section', startedSectionsCount)} Started`}
        stat={startedSectionsCount}
      />
      <StatBox
        boxStyle='pending-box'
        className='pending'
        dataTestid='deputies-added'
        label={`${pluralize('Deputy', deputiesCount, 'Deputies')}`}
        stat={deputiesCount}
      />
      {
        isQuarterback && !isLimitedClient &&
        <Tooltip
          slotProps={{
            popper: {
              disablePortal: true
            }
          }}
          title={tooltipTitle}>
          <span>
            <StatBox
              boxStyle='black-box'
              className='draft-invites'
              dataTestid='draft-invites'
              label={`Draft ${pluralize('Invite', draftDeputiesCount, 'Invites')}`}
              stat={draftDeputiesCount}
            />
          </span>
        </Tooltip>
      }
    </section>
  )
}

Statistics.propTypes = {
  everplanSummary: PropTypes.instanceOf(Map).isRequired,
  isLimitedClient: PropTypes.bool.isRequired,
  isQuarterback: PropTypes.bool.isRequired,
  itemResponses: PropTypes.instanceOf(List)
}

export default Statistics
